// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3664e56","453":"0f4a286b","732":"39143d8e","977":"db544b2c"}[chunkId] + ".chunk.js";
};